import { Component, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseValueAccessor } from 'src/app/core/base/base.value-accessor';
import { generalConsultDetailConstants } from './detail.constants';

@Component({
  selector: 'ms-consult-analysis',
  templateUrl: './analysis.component.html',
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: GeneralConsultAnalysisComponent, multi: true }
  ]
})
export class GeneralConsultAnalysisComponent extends BaseValueAccessor<string> {
  readonly screen = generalConsultDetailConstants.analysis;
  @Input() turn = -1;
  @Input() readonly = false;
  expandSection = true;
}
